import { useEffect, useState } from "react";
import { getParsedStorageItem } from "common/src/utils/localStorageUtils";
import type { CustomView, GroupColors } from "../../../../datagrid/ColumnVisibilityModal";

export interface UseDiscoverGamesGradingArgs {
	storageKey: string;
	customViewsKey: string;
	selectedViewKey: string;
}

export function useDiscoverGamesGrading(args: UseDiscoverGamesGradingArgs) {
	const { storageKey, customViewsKey, selectedViewKey } = args;
	const groupColorsStorageKey = `${storageKey}_groupColors`;

	const [groupColors, setGroupColors] = useState<GroupColors>(() => {
		const views = getParsedStorageItem<CustomView[]>(customViewsKey, []);
		const storedViewId = localStorage.getItem(selectedViewKey);
		if (storedViewId) {
			const selectedView = views.find((v) => v.id === storedViewId);
			if (selectedView?.groupColors) {
				return selectedView.groupColors;
			}
		}
		const defaultView = views.find((v) => v.isDefault);
		if (defaultView?.groupColors) {
			return defaultView.groupColors;
		}
		return getParsedStorageItem<GroupColors>(groupColorsStorageKey, {});
	});

	useEffect(() => {
		localStorage.setItem(groupColorsStorageKey, JSON.stringify(groupColors));
	}, [groupColors, groupColorsStorageKey]);

	return {
		groupColors,
		setGroupColors,
	};
}
